module.exports = "/static/media/lineto-circular-boldItalic.0c2a5e57.woff";